import store from "../../store";
// import {getToken, setToken} from "@/cbd-migration/importSettings";
// import cbdUserTransferUtil from "@/cbd-migration/util/cbdUserTransferUtil";
// import {loadMenuCache, loadUserCache} from "@/cbd-migration/bizCustom";
import { loadUserCache, loadMenuCache } from "@/login/handler/loginHandler";
import LoginThirdPart from "@/login/LoginThirdPart";
import loginService from "@/login/api/login.service";
import menuService from "@/login/api/menu.service";
import CbdMenuTransferUtil from "@/login/util/cbd/CbdMenuTransferUtil";
import ShareUserTransferUtil from "@/login/util/share/ShareUserTransferUtil";
import RecordApi from "@/api/record";
import { getToken, setStore, getStore, removeStore } from "@/util/store";
import LoginApi from "@/api/LoginApi";
import { Message } from "element-ui";
export default async function ssoHandler(to, from, next) {
  let token = getToken();
  if (to.path == "/error") {
    next();
    return;
  }
  //先判断本地是否存在token
  console.log(to.path, "to", { query: to.query }, store.getters.menu.length);
  if (token) {
    //在判断进入的页是否是登录页和sso页面
    if (to.path === "/login") {
      next({ path: "/" });
    } else {
      if (store.getters.menu.length) {
        //切换公司后刷新menu
        if (
          from.path == "/choose_company" &&
          to.path == "/index" &&
          to.query.reload
        ) {
          reloadCache(to, from)
            .then(() => {
              next();
            })
            .catch(err => {
              handleCacheError(err, next);
            });
        } else {
          next();
        }
      } else {
        reloadCache(to, from)
          .then(() => {
            next({ ...to, replace: true });
          })
          .catch(err => {
            handleCacheError(err, next);
          });
      }
    }
  } else {
    console.log("haselse");
    const query = { ...to.query };
    const ssoCode = query['code'];
    const loginTest = query.logintest;
    // username + ticket 免登录
    const ticketLogin = query.username && query.ticket;

    // 剔除sso多余参数污染路由
    const cleanQuery = { ...to.query };
    delete cleanQuery['code'];
    delete cleanQuery['state'];
    delete cleanQuery['username'];
    delete cleanQuery['ticket'];
    // 针对零信任的处理，需要重新认证一下
    if ((!ssoCode && !loginTest && !ticketLogin) || query.state == "sag") {
      location.href = LoginThirdPart.getStraightThirdPartLoginUrl();
    }

    if (ssoCode || loginTest || ticketLogin) {
      LoginThirdPart.loginTicket(query)
        .then(res => {
          setStore("token", res.data.access_token);
          store.dispatch("setToken", res.data.access_token);
          next({ ...to, replace: true, query: cleanQuery });
        })
        .catch(() => {
          // location.href = LoginThirdPart.getStraightThirdPartLoginUrl();
        });
    } else {
      // 没有token
        location.href = LoginThirdPart.getStraightThirdPartLoginUrl();
    }
  }
}

function handleCacheError(err, next) {
  if (err && err.handled) {
    return;
  }
  if (err && err.message) {
    Message.error(err.message);
  }
  if (err && err.redirect) {
    next(err.redirect);
    return;
  }
  next("/login");
}

function reloadCache(to, from) {
  return reloadUser()
    .then(async res => {
      console.log("res:", res);
      let recordApi = new RecordApi();
      // 有res取res 没有取vuex缓存 默认company的id有问题
      try {
        const record = await recordApi.detail({
          // companyId: res.currentCompanyId || store.state.user.userInfo.companyId
          companyId:
            res.user.currentCompanyId || store?.state?.user?.userInfo?.companyId
        });
        console.log("record:", record);
        if (record.code == 500) {
          return Promise.reject({ redirect: "/error" });
        }
        await store.dispatch("setSigner", record.data);
        if (record.data) {
          localStorage.setItem("wsb", record.data.wsb);
          // 除去集团公司，其他满足条件都去公司备案页面
           const excludedUsers = ["王佳欣","陈汜芸"];
          if (
            record.data.entRecord.status !== "60" &&
            to.path !== "/company_on_record" &&
            record.data.entRecord.companyId !== "1000000000000000000"&&
            !excludedUsers.includes(res.user.accountName)
          ) {
            return Promise.reject({ redirect: "/company_on_record" });
          } else if (
            record.data.entRecord.status === "60" &&
            to.path !== "/company_on_record" &&
            !record.data.zb &&
            record.data.entRecord.companyId !== "1000000000000000000"&&
            !excludedUsers.includes(res.user.accountName)
          ) {
            return Promise.reject({ redirect: "/company_on_record" });
          }
        }
      } catch (error) {
        return Promise.reject({ redirect: "/error" });
      }
      if (to.query.redirectUrl) {
        window.location.href = to.query.redirectUrl;
        return Promise.reject({ handled: true });
      } else {
        return reloadMenu(to, from);
      }
    })
    .catch(async err => {
      if (err && err.redirect) {
        return Promise.reject(err);
      }
      setStore("token", "");
      store.dispatch("setToken", "");
      return Promise.reject({ redirect: "/login" });
    });
}

export function reloadUser() {
  console.log("reloadUser:", loginService);
  return loginService.getInfo({}).then(async rs => {
    console.log("rs:", rs);
    let shareUserDetail = ShareUserTransferUtil.transfer(rs.user);
    await loadUserCache(shareUserDetail);
    return rs;
  });
}

function reloadMenu(to, from) {
  let flag = true;
  const whiteList = store.getters.website.whiteList;
  if (whiteList != undefined && whiteList != null) {
    for (let i = 0; i < whiteList.length; i++) {
      if (new RegExp("^" + whiteList[i].toString() + ".*", "g").test(to.path)) {
        flag = false;
        break;
      }
    }
  }
  if (flag) {
    const value = to.query.src ? to.query.src : to.path;
    const label = to.query.name ? to.query.name : to.name;
    store.commit("ADD_TAG", {
      label: label,
      value: value,
      query: to.query
    });
  }
  return menuService.getMenu().then(async res => {
    await loadMenuCache(CbdMenuTransferUtil.transferList(res.data));
  });
}
